export default "__VITE_ASSET__BtmnyEWs__"